import React, { useEffect, useState } from "react";
import { QuickUser } from "./QuickUser/QuickUser";
import { Modal, Offcanvas, Dropdown, OverlayTrigger, Tooltip, Button, Image, Table } from 'react-bootstrap';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { togglePlanSection } from "../../../actions/show_modal_Action";
import { closePricingModal } from "../../../utils/close_modal";
import { updateSelectedCollabratorToken } from "../../../actions/collabratorAction";
import { HOST_URL, MediaBaseUrl, READ_NOTIFICATION_API } from "../../../actions/api";
import ReactHtmlParser from 'react-html-parser';
import { decrypt, getInitialRoute, replaceDomain, validateUserPicture } from "../../../utils";
import { WIDGET_WALLS_DATA } from "../../../actions/wallsAction";
import { togglePlanSection_D } from "../../../actions/showDisplayModalAction";
import HttpClient from "../../../actions/http-client";
import { getAllNotification } from "../../../actions/notificationAction";
import { getWidgetWallData } from "../../../actions/wallDataAction";
import { getUseronboardingInfo, isSocialWallUser, logOutUser } from "../../../actions/loginActions";
import ProfileImage from "../../CommonComponents/ProfileImage";
import { getProductAndPlanDetails } from "../../../actions/product_details_action";
import { MOD_NOTI, PRODUCT_CANCELANCELLATION_STATUS } from "../../../reducers/keys";
import { FontAwesomeIcon } from "../../CommonComponents/AssetsHelper";
import MFALogin from "../../Authorization/MFALogin";
import { getModeration } from "../../../actions/moderationActions";
import UpgradeBtn from "../../CommonComponents/UpgradeBtn";

export function Header(props) {
    const [isActive, setActive] = useState("false");
    const [isMenu, setIsMenu] = useState(props.windowWidth > 992 ? false : true);
    const { showUgcSuit } = useSelector(state => state.showPlanSection, shallowEqual);
    const { latestNotifionList } = useSelector(state => state.notification, shallowEqual);
    const { plans } = useSelector(state => state.planDetails, shallowEqual);
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const { collabratorList, selectedCollabrator } = useSelector(state => state.collabratorSection, shallowEqual);
    const [isUgcSelected, setUgcSelected] = useState(showUgcSuit);
    const isPlanExceeded = localStorage.getItem('plan_exceeded');
    const [openMfa, setOpenMfa] = useState(false);
    const [mfaToken, setMfaToken] = useState(false);

    const [selectedColab, setSelectedCollabrator] = useState(selectedCollabrator ? selectedCollabrator : collabratorList.length > 0 ? collabratorList.filter((collab) => collab.userId === JSON.parse(localStorage.getItem('ownerId')))[0] : []);
    const { user, UserPlan } = userData;

    const updateMessage = user && Object.keys(user).length > 0 ? user.updateMessage : "";
    const pathname = window.location.pathname;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleToggle = () => {
        setActive(!isActive);
        if (isActive) {
            document.body.classList.add('aside-minimize');
        } else {
            document.body.classList.remove('aside-minimize');
        }
    };


    const readNotification = (id, url, index) => {

        var arr = url.split("/");

        if (arr && arr[index] && !arr[index]?.includes("notification")) {
            localStorage.setItem("wallId", arr[index]);
        }

        new HttpClient().get(`${READ_NOTIFICATION_API}${id}`).then((response) => {
            dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby: "message", direction: "ASC" }, true));
            if (response.data.responseData && Object.keys(response.data.responseData.posts).length > 0) {
                dispatch({ type: MOD_NOTI, payload: response.data.responseData })
                dispatch(getModeration());
            }
        }).catch(ex => console.log("error"));
    }


    useEffect(() => {
        const url = window.location.pathname;
        if (url.includes('socialwalls')) {
            window.localStorage.setItem("product", 1)
        } else if (url.includes('display')) {
            window.localStorage.setItem("product", 0)
        }

    }, []);

    const changeOwner = (link) => {
        const ownerId = link.split("/");
        collabratorList.map((collabrator) => {
            if (collabrator.userId == ownerId[2]) {
                updateSelectedCollabrator(collabrator)
                return false
            }
        })
    }

    const getRouteNotification = (link) => {
        const url = link.split('/');
        if (url[0] === 'analytic') {
            dispatch(getWidgetWallData(localStorage.getItem("ownerId"), url[1]))
            setTimeout(() => {
                navigate(`/${link}`)
            }, 1000);

        } else {
            navigate(`/${link}`)
        }
    }


    const getNotificationAction = (action, getNotificationUrl, message, id) => {

        const getNotificationUrlManage = getNotificationUrl;
        const changeowner = getNotificationUrlManage.includes("changeowner");
        const redirectUrl = replaceDomain(getNotificationUrlManage);
        const isAnalytic = getNotificationUrl.includes('analytic');
        const actionClass = `cursor-pointer resetAction ${action !== 'init' ? action : ''}`;

        const handleReadNotification = () => readNotification(id, getNotificationUrl, isAnalytic ? 1 : 2);
    

        if (action === 'init') {
            return changeowner ? <div className={actionClass} onClick={() => { changeOwner(getNotificationUrlManage); handleReadNotification(); }} > {ReactHtmlParser(message)} </div>
                : <div className={actionClass} onClick={() => { handleReadNotification(); getRouteNotification(redirectUrl) }}> {ReactHtmlParser(message)}</div>
        } else if (action === 'popup') {
            return <a className={actionClass} onClick={() => dispatch(togglePlanSection_D(true))}> {ReactHtmlParser(message)} </a>
        } else if (action === 'ugc') {
            return <Link to={`/${getNotificationUrl}`} className={actionClass} target='_blank'> {ReactHtmlParser(message)} </Link>
        }

        return <Link onClick={() => { handleReadNotification() }} to={`/${redirectUrl}`} className={actionClass}> {ReactHtmlParser(message)} </Link>
    }

    const [show, setModalShow] = useState(false);
    const modalHandleClose = () => setModalShow(false);
    const modalHandleShow = () => setModalShow(true);

    const [showOfCanves, setOfCanvasShow] = useState(false);
    const OfCanvasHandleClose = () => setOfCanvasShow(false);
    const OfCanvasHandleShow = () => setOfCanvasShow(true);

    const ProductMenuAsideClose = () => {
        props.isActiveProAsideFun(false)
    };

    const getUnreadNotification = (list) => {
        return list.reduce((acc, curr) => {
            if (curr.status === 0) {
                acc++;
            }
            return acc;
        }, 0)
    }

    const checkMfaCollabrator = (collabrator) => {
        if (collabrator?.is_mfa_enable) {
            setMfaToken(collabrator?.mfa_token);
            setOpenMfa(true); 
        }else{
            updateSelectedCollabrator(collabrator);
        }
    }
    
    const updateSelectedCollabrator = (collabrator) => {
        if(openMfa){ setOpenMfa(false); setMfaToken(null); }
        if (selectedColab.userId !== collabrator.userId) {
            const isColl = ((localStorage.getItem('loginOwnerId')) == collabrator.loginOwnerId) || !collabrator.userhashId;
            localStorage.setItem('isCollaborator', isColl ? 0 : 1);
            dispatch(updateSelectedCollabratorToken(collabrator));
            setSelectedCollabrator(collabrator);
            const product = getInitialRoute();

            if (isColl) {
                if (window.location.pathname === `/walls`) {
                    dispatch(WIDGET_WALLS_DATA());
                } else {
                    navigate(`/walls/home`);
                }
            } else {
                if (window.location.pathname === `/walls`) {
                    dispatch(WIDGET_WALLS_DATA());
                } else {
                    navigate(`/walls`);
                }
            }
        }
    }

    const seeAllNotification = () => {
        closePricingModal(dispatch);
        navigate(`/notifications`);
    }


    const upgradeHandle = () => {
        dispatch(getInitialRoute() == 'widget' ? togglePlanSection(true) : dispatch(togglePlanSection_D(true)));
        dispatch({ type: PRODUCT_CANCELANCELLATION_STATUS, payload: false })
    }

    const product = getInitialRoute();

    return <>
        <div id="kt_header" className={`header bg-white border-bottom position-lg-sticky header-fixed `}>
            <div className="container-fluid f-stretch h-100">
                <div className={`header-menu-wrapper header-menu-wrapper-left flex-grow-1 ${props.isActiveProAside ? 'header-menu-wrapper-on' : ''}`} id="kt_header_menu_wrapper">
                    <div id="kt_header_menu" className="header-menu header-menu-mobile header-menu-layout-default f-stretch h-100">

                        {!window.location.pathname.includes('/studio') ? <div className="d-flex align-items-center">
                            <Button variant="" className={`brand-toggle btn-sm border-0 p-0 toggle_icon_`} id="kt_aside_toggle" onClick={handleToggle}>
                                <FontAwesomeIcon type={'regular'} icon={'bars-sort'} iconClass={'fs-2 p-0'} />
                            </Button>
                        </div> : <></>}

                    </div>
                </div>

                {props.isActiveProAside ? <div className="header-menu-wrapper-overlay" onClick={ProductMenuAsideClose}></div> : null}
                {/* topbar */}
                <div className="f-center topbar-new justify-content-md-end justify-content-center flex-md-nowrap flex-wrap ">
                    {updateMessage != "" ? <p className={`px-2 py-3 m-0 d-sm-inline d-none text-dark`}>{updateMessage}</p> : null}
                    <div className="topbar-item me-sm-3 me-2 upgrade_notifiction"> <UpgradeBtn /> </div> 
                    {!(isPlanExceeded || pathname.includes('extrawallfeeds') || pathname.includes('accounts/expire')) && collabratorList && collabratorList.length > 0 && !isUgcSelected ? <Dropdown>
                        <div className="topbar-item">
                            <Dropdown.Toggle variant="outline-secondary" className="btn-icon border w-auto d-inline-flex align-items-center py-2 px-sm-3 px-2 me-sm-3 me-2 arrow_disabled">
                                <span className="font-weight-bolder font-size-sm me-2">{selectedColab && selectedColab.name}</span>
                                <span className="svg-icon">
                                    <FontAwesomeIcon type={'regular'} icon={'angle-down'} iconClass={'fs-6 text-secondary'} />
                                </span>
                            </Dropdown.Toggle>
                        </div>
                        <Dropdown.Menu className="dropdown-menu-sm collaborator_dropdown">
                            <ul className="navi navi-hover m-0 p-0">
                                {
                                    collabratorList.map((collabrator) => <li className="navi-item" key={collabrator?.userId}>
                                        <Dropdown.Item className="navi-link py-2 px-3 d-flex align-items-center" onClick={() => checkMfaCollabrator(collabrator)}>
                                            <span className="w-30px h-30px rounded-circle symbol-light-warning me-2 f-center">
                                                <div className="symbol-label" style={{ backgroundImage: `url(${collabrator?.picture?.length > 1 ? collabrator?.picture : ''})` }}>{collabrator?.picture?.length === 1 && collabrator?.picture}</div>
                                            </span>
                                            <span className="navi-text flex-grow-1">{collabrator?.name}</span>
                                        </Dropdown.Item>
                                    </li>)
                                }
                            </ul>
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {!(isPlanExceeded || pathname.includes('extrawallfeeds')) && !isUgcSelected ? getInitialRoute() != 'ugcsuite' ? <div className="me-3">
                        <Link className="btn-link timerNclock cursor-pointer f-center" onClick={modalHandleShow}>
                            <FontAwesomeIcon type={'regular'} icon={'clock'} iconClass={'fs-5'} />
                            <span className="ms-2 d-none d-md-inline updateTimeVal">{user ? user.updateTime : "5 minutes"}</span>
                        </Link>
                    </div> : null : null}
                    {!(isPlanExceeded || pathname.includes('extrawallfeeds')) && <Dropdown>
                        <div className="me-sm-3 me-2">
                            <Dropdown.Toggle variant="" className="arrow_disabled btn-link">
                                <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5'} />
                            </Dropdown.Toggle>
                        </div>
                        <Dropdown.Menu className="dropdown-menu-sm" style={{ minWidth: 185 }}>
                            <Dropdown.Item className="d-flex aling-items-center" onClick={window.Intercom ? (e) => { window.Intercom('show') } : () => { }}>
                                <FontAwesomeIcon type={'regular'} icon={'comment-dots'} iconClass={'fs-5'} />
                                <span className="ms-3">Chat</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="https://calendly.com/taggbox/demo?utm_source=Widget&utm_medium=https://app.taggbox.com/widget/&utm_campaign=calendly_Request_demo_click" target="_blank" className="d-flex aling-items-center">
                                <FontAwesomeIcon type={'regular'} icon={'phone-volume'} iconClass={'fs-5'} />
                                <span className="ms-3">Call</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="mailto:support@socialwalls.com" className="d-flex aling-items-center">
                                <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'fs-5'} />
                                <span className="ms-3">Email</span>
                            </Dropdown.Item>
                            <Dropdown.Item href={`https://taggbox.com/support/${product != 'ugcsuite' ? product : 'widget'}/`} target="_blank" className="d-flex aling-items-center">
                                <FontAwesomeIcon type={'regular'} icon={'book-open'} iconClass={'fs-5'} />
                                <span className="ms-3">Knowledge Base</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>}
                    <Dropdown>
                        {product != 'ugcsuite' ? <div className="me-sm-3 me-2">
                            <Dropdown.Toggle variant="" className="arrow_disabled btn-link" >
                                <audio id="notify">
                                    <source src={`${MediaBaseUrl}misc/notify.ogg`} type="audio/ogg" />
                                    <source src={`${MediaBaseUrl}misc/notify.mp3`} type="audio/mpeg" />
                                    <source src={`${MediaBaseUrl}misc/notify.wav`} type="audio/wav" />
                                </audio>
                                {getUnreadNotification(latestNotifionList) !== 0 && <span className="notifications_count position-absolute end-0 badge-gradient rounded-circle">{
                                    latestNotifionList.length > 0 ? getUnreadNotification(latestNotifionList) : 0
                                }</span>}
                                <FontAwesomeIcon type={'regular'} icon={'bell'} iconClass={'fs-5'} />
                                <span className="pulse-ring"></span>
                            </Dropdown.Toggle>
                        </div> : null}
                        {!(isPlanExceeded || pathname.includes('extrawallfeeds') || pathname.includes('expire')) && localStorage.getItem('isCollaborator') != '1' && <Dropdown.Menu className="p-0 dropdown-menu-xl">
                            <div className="d-flex flex-column p-3 border-bottom">
                                <h6 className="f-between mb-0">
                                    <span className="text-dark">Notifications</span>
                                    {getUnreadNotification(latestNotifionList) !== 0 && latestNotifionList.length > 0 && <span className="btn btn-primary py-1 p-3">{
                                        latestNotifionList.length > 0 ? getUnreadNotification(latestNotifionList) : 0
                                    }</span>}
                                </h6>
                            </div>
                            <div className="tab-content">
                                <div className="tab-pane active show" id="topbar_notifications_notifications" role="tabpanel">
                                    <div className="notifications_wrap h-250px overflow-auto">
                                        {
                                            latestNotifionList.length > 0 ? latestNotifionList.map((notification) => {
                                                //if (notification.status === 0) {
                                                return (
                                                    <li className={`needReview removeNotification${notification.id} ${notification.statusText} clearfix`} key={notification.id}>
                                                        {getNotificationAction(notification.action, notification.getNotificationUrl, notification.message, notification.id)}
                                                    </li>)
                                                // }
                                            }) : <div className="text-center h-100 d-flex justify-content-center align-items-center">No New Notification</div>
                                        }
                                    </div>
                                    <div className="d-flex flex-center border-top">
                                        <div onClick={() => seeAllNotification()} className="font-weight-bolder text-center font-size-sm dropdown-item cursor-pointer">
                                            See All notification
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Dropdown.Menu>}
                    </Dropdown>
                    {product != 'ugcsuite' ? <div className="me-sm-2 me-0">
                        <div className="f-center cursor-pointer" onClick={OfCanvasHandleShow}>
                            <span className="f-center rounded-circle position-relative symbol-light-warning userProfilePicture">
                                {user && user.picture ?
                                    <ProfileImage className={'symbol-35 f-center rounded-circle symbol-light-warning fs-5 text-uppercase overflow-hidden'}
                                        imageSize={35}
                                        symbolClass={'symbol-label text-light-alt fw-bolder text-uppercase fs-5'}
                                        name={user.name} profileUrl={validateUserPicture(user.picture)} networkId={31} />
                                    :
                                    <span className="symbol-35 f-center rounded-circle symbol-light-warning fs-5 text-uppercase">{user && user.name ? String(user.name)[0] : ""}</span>}
                                <span className="premium-user-sign userLoginStar">
                                    {user && user.isPremiumUser === 1 ? <Image src={`${MediaBaseUrl}svg/icons/profile-star.svg`} className="img-fluid" alt="profile star" width={'16'} height={'16'} /> : null}
                                </span>
                            </span>
                        </div>
                    </div> : null}
                </div>
            </div>
        </div>
        <Offcanvas show={showOfCanves} placement={'end'} name={'end'} className="p-4" onHide={OfCanvasHandleClose}>
            {localStorage.getItem('Isadmin') ?
                <div onClick={() => logOutUser(true)} className="whitelabelanchor btn btn-sm btn-secondary font-weight-bolder py-2 px-5 d-block mb-4">Back to Admin</div> : null}

            <div className="offcanvas-header justify-content-between">
                <h5 className="m-0">Profile </h5>
                <Button variant="outline-secondary" onClick={() => setOfCanvasShow(false)} className="py-0 px-2" data-bs-dismiss="offcanvas" id="kt_quick_user_close">
                    <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6'} />
                </Button>
            </div>

            <Offcanvas.Body className="p-0">
                <QuickUser prefix={product} isPlanExceeded={isPlanExceeded} closeUgcModal={() => {
                    setUgcSelected(false);
                }} isUgcSelected={isUgcSelected} />
            </Offcanvas.Body>
        </Offcanvas>

        <Modal show={show} onHide={modalHandleClose} backdrop="static" size="md" keyboard={false} centered>
            <Modal.Body>
                <Button variant="link" onClick={modalHandleClose} className="px-2 float-end">
                    <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6'} />
                </Button>
                <div className="p-4">
                    <div className="pb-5 text-center">
                        <img className="img-fluid mb-4" src={`${MediaBaseUrl}svg/upgrade-svg.svg`} height={140} width={140} alt="Time Update" />
                        <h4 className="mb-3">Automatic content update time</h4>
                        <p className="fw-medium text-secondary m-0">
                            Update time means how fast the new content will be updated automatically on your Social feeds/walls.
                        </p>
                    </div>
                    <div className="pb-3">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Plans</th>
                                    <th>Update Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Weekly Pass</td>
                                    <td>Real-Time</td>
                                </tr>
                                <tr>
                                    <td>Lite</td>
                                    <td>30 Minutes</td>
                                </tr>
                                <tr>
                                    <td>Enterprise</td>
                                    <td>Custom</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    <p className="fw-medium text-secondary m-0 text-center">
                        <small>  <strong>Note:</strong> Due to API limitations, LinkedIn feeds may take up to 24 hours to update, while Twitter feeds will refresh every 4-6 hours</small>
                  
                        </p>

                    {UserPlan.planId == 1 ?
                        <div className="text-center">
                            <p><strong>Note:</strong> Experience real-time updates for the first 2 hours of your free trial or until 500 posts are fetched, whichever comes first.</p>
                            <button type="button" className="btn btn-primary upgPlan" data-bs-dismiss="modal" onClick={() => { product != 'widget' ? dispatch(togglePlanSection_D(true)) : dispatch(togglePlanSection(true)); modalHandleClose() }}>Upgrade Plan</button>
                        </div> : null}
                </div>
                <OverlayTrigger placement="right" overlay={<Tooltip>Know More</Tooltip>}>
                    <a href="https://taggbox.com/support/what-is-update-time/" target="_blank" className="modal_tooltip text-muted">
                        <FontAwesomeIcon type={'regular'} icon={'circle-question'} />
                    </a>
                </OverlayTrigger>
            </Modal.Body>
        </Modal>


        <Modal className="mfa-modal" show={openMfa} onHide={() => setOpenMfa(false)} backdrop="static" keyboard={false} centered size={"md"}>
            <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
            <Modal.Body>
                <MFALogin mfaCollabratorToken={mfaToken} isCollabrator={true} updateSelectedCollabrator={updateSelectedCollabrator}/>
            </Modal.Body>
        </Modal>
    </>
}
